/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { StyleProp, View, ViewStyle } from "react-native";

import { skaleDeactiveGray, skaleBlue } from "config/UpduoColors";

interface PaginationDotsProps {
  activeColor?: string;
  passiveColor?: string;
  size?: number;
  stepCount?: number;
  currentPosition?: number;
  showOnlyCurrent?: boolean;
  style?: StyleProp<ViewStyle>;
}

export default function PaginationDots({
  activeColor = skaleBlue,
  passiveColor = skaleDeactiveGray,
  size = 10,
  stepCount = 4,
  currentPosition = 0,
  showOnlyCurrent = false,
  style,
}: PaginationDotsProps) {
  const paginationDotsArray = new Array(stepCount).fill(0);

  return (
    <View style={[{ flexDirection: "row" }, style]}>
      {paginationDotsArray.map((item, index) => (
        <View
          key={index}
          style={{
            marginTop: currentPosition === 0 || currentPosition === 2 ? 0 : 25,
            marginHorizontal: 5,
            width: size,
            height: size,
            borderRadius: size / 2,
            backgroundColor: (
              showOnlyCurrent
                ? index === currentPosition
                : index <= currentPosition
            )
              ? activeColor
              : passiveColor,
          }}
        />
      ))}
    </View>
  );
}
